import React from 'react';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent.typed';

import AutoDeliveryDcxSection from './AutoDeliveryDcxSection';
import AutoDeliveryDcxSectionButton from './AutoDeliveryDcxSectionButton';

interface AutoDeliveryDcxHelpSupportProps {
    className?: string;
}

const AutoDeliveryDcxHelpSupport = ({className}: AutoDeliveryDcxHelpSupportProps) => {
    const content = appContent.getAutoDeliveryContent()?.extendedDetailsContent;

    if (!content) return null;

    const {helpSupportViewButton, helpSupportTitle, helpSupportIcon, helpSupportInfoTitle, helpSupportInfoDescription} =
        content;
    const actionButton = <AutoDeliveryDcxSectionButton button={helpSupportViewButton} />;

    return (
        <AutoDeliveryDcxSection className={className} title={helpSupportTitle} action={actionButton}>
            <div className='mt-4 flex items-center gap-2'>
                <RemoteIconV2 icon={helpSupportIcon} className='shrink-0 self-start' />
                <div>
                    <p className='text-14 leading-[20px] tracking-02'>{helpSupportInfoTitle}</p>
                    <p className='mt-2 text-12 leading-[16px] tracking-02 text-primary-dark-85'>
                        {helpSupportInfoDescription}
                    </p>
                </div>
            </div>
        </AutoDeliveryDcxSection>
    );
};

export default AutoDeliveryDcxHelpSupport;
